import {
  IAction,
  KEEP_THE_SAME,
  StateStatus,
} from '../../../redux/utils/common';
import * as Types from './types';

export interface IState {
  paymentRemindersList: any;
  paymentRemindersGenerateStatus: StateStatus | undefined;
}

const initialState: IState = {
  paymentRemindersList: {
    status: null,
    data: null,
  },
  paymentRemindersGenerateStatus: undefined,
};

const PaymentRemindersReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PAYMENT_REMINDERS_LIST:
      return {
        ...state,
        paymentRemindersList: {
          ...state.paymentRemindersList,
          status: action.status,
          data:
            action.data === KEEP_THE_SAME
              ? state.paymentRemindersList.data
              : action.data,
        },
      };
    case Types.SET_PAYMENT_REMINDERS_TO_GENERATE:
      return {
        ...state,
        paymentRemindersGenerateStatus: action.status,
      };
    default:
      return {
        ...state,
      };
  }
};

export default PaymentRemindersReducer;
